import React from "react";
import PropTypes from "prop-types";

import ExportForm from "../../../../containers/Admin-portal/Events/ViewEvent/ApplicantsTab/ExportModal";
import { UIActionModal } from "../../../ui";

const ApplicantsExportModal = ({
  open,
  title,
  subtitle,
  cancelLabel,
  confirmLabel,
  fields,
  selectedFields,
  isAllSelected,
  confirmDisabled,
  exportDate,
  dateError,
  onClose,
  onConfirm,
  onFieldChange,
  onSelectAll,
  onDateChange,
}) => (
  <UIActionModal
    open={open}
    title={title}
    onClose={onClose}
    variant="info"
    maxWidth="md"
    PaperProps={{ className: "admin-applicants-export-modal" }}
    actions={
      <UIActionModal.Actions
        cancelLabel={cancelLabel}
        confirmLabel={confirmLabel}
        confirmDisabled={confirmDisabled}
        onCancel={onClose}
        onConfirm={onConfirm}
      />
    }
  >
    <p className="admin-applicants-export-modal__subtitle">{subtitle}</p>
    <UIActionModal.Divider />
    <ExportForm
      selectedFields={selectedFields}
      handleChange={onFieldChange}
      handleSelectAll={onSelectAll}
      isAllSelected={isAllSelected}
      handleSubmit={onConfirm}
      handleGetDate={onDateChange}
      dateError={dateError}
      exportDate={exportDate}
      fields={fields}
    />
  </UIActionModal>
);

ApplicantsExportModal.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node.isRequired,
  cancelLabel: PropTypes.node.isRequired,
  confirmLabel: PropTypes.node.isRequired,
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      label: PropTypes.node.isRequired,
    }),
  ).isRequired,
  selectedFields: PropTypes.object.isRequired,
  isAllSelected: PropTypes.bool.isRequired,
  confirmDisabled: PropTypes.bool.isRequired,
  exportDate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  dateError: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  onSelectAll: PropTypes.func.isRequired,
  onDateChange: PropTypes.func.isRequired,
};

ApplicantsExportModal.defaultProps = {
  exportDate: null,
};

export default ApplicantsExportModal;
